enum PageLayout {
    None,
    Standard,
    FullScreen,
    Project,
    Group
}

export default PageLayout;
